import { isAnyOf } from "@reduxjs/toolkit";
import { appListenerMiddleware } from "../../appListenerMiddleware";
import { setSelectedObjectId } from "../../../../../app/state/storageObjectSlice/slice";
import {
  getThreadRunAction,
  postMessageWithResponsesAction,
} from "../../../../../features/Assistants/redux/actions";
import { RootState } from "../../../types";
import { AssistantValue } from "../../../../api/instances/assistantsApi/types";
import { setChatLogs } from "../../../../../features/Assistants/redux/slice";

const pollingTimers = new Map<string, NodeJS.Timeout>();

export function appPollingListener() {
  appListenerMiddleware.startListening({
    predicate: isAnyOf(
      postMessageWithResponsesAction.pending,
      postMessageWithResponsesAction.fulfilled,
      postMessageWithResponsesAction.rejected,
      setSelectedObjectId,
    ),
    effect: (action, listenerApi) => {
      const { getState, dispatch } = listenerApi;
      const args = (action as any).meta?.arg;
      const threadRef = args?.threadRef;
      const state = (getState() as RootState).storageObjectState["assistants"];

      const id = state.selectedId;
      if (!id) return;

      if (action.type === setSelectedObjectId.type) {
        pollingTimers.forEach((timerId, threadId) => {
          clearInterval(timerId);
        });
        pollingTimers.clear();

        return;
      }

      const selectedObject = state.data.entities[id];
      if (!selectedObject) return;

      const assistantValue = selectedObject.value as AssistantValue;

      if (!assistantValue?.assistant_object) return;
      if (!threadRef) return;

      if (action.type === postMessageWithResponsesAction.pending.type) {
        if (!pollingTimers.has(threadRef)) {
          const timerId = setInterval(() => {
            dispatch(getThreadRunAction({ thread_ref: threadRef, id: id }));
          }, 2000);

          pollingTimers.set(threadRef, timerId);
        }
      } else if (
        action.type === postMessageWithResponsesAction.fulfilled.type ||
        action.type === postMessageWithResponsesAction.rejected.type
      ) {
        if (pollingTimers.has(threadRef)) {
          console.log(`[Polling] Stop polling for thread: ${threadRef}`);
          listenerApi.dispatch(setChatLogs({ id: id, log: "" }));
          clearInterval(pollingTimers.get(threadRef)!);
          pollingTimers.delete(threadRef);
        }
      }
    },
  });
}
